import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	AddAnalysisPage,
	mapPlantAnalysisToForm,
	mapSoilAnalysisToForm,
} from '@practium/features/analyses';
import type { AnalysesTab } from '@practium/features/analyses';
import { useGetPlantAnalysisById, useGetSoilAnalysisById } from '@practium/features/api';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';

export const ViewAnalysisPageClient = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { abilities } = usePermissions();
	const { isForBinding } = useForBinding();
	const subject = isForBinding ? 'farmers-samples' : 'samples';
	const canEdit = abilities.can('update', subject);
	const canDelete = abilities.can('delete', subject);
	const type = (searchParams.get('type') as AnalysesTab) || 'soil';
	const id = searchParams.get('id') || '';

	const soilQuery = useGetSoilAnalysisById(id, {
		enabled: type === 'soil' && !!id,
		select: mapSoilAnalysisToForm,
	});

	const plantQuery = useGetPlantAnalysisById(id, {
		enabled: type === 'plant' && !!id,
		select: mapPlantAnalysisToForm,
	});

	const initialData = type === 'soil' ? soilQuery.data : plantQuery.data;

	if (!initialData) return null;

	return (
		<AddAnalysisPage
			type={type}
			onBack={() => navigate('/analises')}
			initialMode="view"
			initialData={initialData}
			analysisId={id}
			onDelete={canDelete ? () => navigate('/analises') : undefined}
			canEdit={canEdit}
		/>
	);
};
